
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { EventsService, SeoService, UtilService, VariablesService, VwoService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { ExitIntentComponent } from 'src/app/common/exit-intent/components/exit-intent/exit-intent.component';
import { HomepageModule } from './components/homepage.module';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { InViewportModule } from 'ng-in-viewport';
import { SacFlowModule } from 'src/app/common/sac-flow/sac-flow.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DownloadAppBannerModule } from 'src/app/common/download-app-banner/download-app-banner.module';
import { StartfundraiserButtonModule } from 'src/app/common/startfundraiser-button/startfundraiser-button.module';
import { LandscapeViewModule } from 'src/app/common/landscape-view/landscape-view.module';
import { HomeComponentNonLoggedInV2 } from './home-v2/home-non-logged-In-v2.component';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, InViewportModule, ComponentLoader, SacFlowModule, HomepageModule, DownloadAppBannerModule, StartfundraiserButtonModule, SharedModule, LandscapeViewModule, HomeComponentNonLoggedInV2],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  ExitlistenerFn: () => void;
  isLoggedIn: boolean;
  draftData;
  componentInView = {
    'what-we-offer': false,
    'trending': false,
    'crowdfunding': false,
    'successtories': false,
    'featuredin': false,
    'causes': false,
    'get-started': false,
    'fundraisingFeature': false,
    'footer': false,
    'sacflow': false
  };
  metaData;
  isLoginPopUpOpen = false;
  mouseY = 0;
  popupCounter = 0;
  isSipSubscribed = false;

  subs: Subscription[] = [];
  userData;
  isMobile;
  isAnySip = 0;
  public freqVisitedCampaigns: number[] = [];

  constructor(
    public util: UtilService,
    public dialog: MatDialog,
    private seoService: SeoService,
    private events: EventsService,
    private vars: VariablesService,
    @Inject(DOCUMENT) private document: any,
    public vwo: VwoService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.isMobile = this.util?.isMobile();
    this.freqVisitedCampaigns = this.util.getFrequentVisitedCampaigns();
    this.sipMcdRedirectUser();
    this.util.scrollToTop();
    this.addReviewSchema();
    this.vars.pageName = 'home';
    this.loadSeoData();
    this.vars.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      animateHeader: true,
      headerClass: 'homepage-header white-bg download-app-banner',
      headerTopSticky: true,
      showCurrency: false,
      zendesk: true,
      showFooterSEO: true
    });
    if (typeof document !== 'undefined') {
      this.document.body.classList.add('homePage');
    }
    // this.ExitlistenerFn = this.exitIntent();
    this.seoService.updateCanonicalURL('');

    this.subs.push(this.vars.userData.subscribe(res => {
      if (res?.listsubscriptions) {
        this.isAnySip = this.util.checkForActiveSip(res?.listsubscriptions);
      }
      const userObj = this.util.storage.get('user');
      const isPermanentLogin = userObj?.user?.isLoggedIn;
      if (isPermanentLogin) {
        this.userData = res;
        this.isLoggedIn = true;
      } else {
        this.userData = null;
      }
    }));
    this.subs.push(this.vars.draftData.subscribe(draft => {
      this.draftData = draft;
      const user = this.util.storage.get('user');
      const isPermanentLogin = user?.user?.isLoggedIn;
      let pathname;
      if (this.util.isBrowser) {
        pathname = window.location.pathname;
      }
      this.vars.homeV2.next(this.userData && isPermanentLogin && (!this.draftData || this.draftData?.status_flag === 7) && pathname === '/');
    }));
    this.pageViewEvent();
  }

  sipMcdRedirectUser() {
    this.subs.push(this.vars.userData.subscribe({
      next: (res) => {
        this.isSipSubscribed = res?.listsubscriptions?.medical?.status_flag?.toString().match('1|2|3|4') ? true : false;
        const userData = this.util.getUser();

        if ((userData && userData?.user?.user_type === 'campaigner'
          && userData?.all_active_campaigns
          && userData?.all_active_campaigns?.length > 0)) {

          this.util.nativeNavigation(environment.manage_domain + '/manage/list');
        } 

        /** 
         * sip retention redirect code removed
         * else if (this.isSipSubscribed) {
            if (!this.util.storage.getFromSession('sipUserRedirect')) {
              let url = environment.sipretention_domain;
              if (res?.listsubscriptions?.medical?.status_flag?.toString().match('2|4|5')) {
                url += '/inactiveuser';
              }
              this.util.storage.addSessionData('sipUserRedirect', true);
              this.util.nativeNavigation(url);
            }
          }
         * 
        */
      }
    }));
  }

  addReviewSchema() {
    const reviewSchema = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      'name': 'Crowdfunding India - Ketto is a Crowdfunding Platform based out of India',
      'description': 'Ketto is crowdfunding website in India! With Ketto.org you can Start Campaigns to raise funds for causes such as Medical, Education, Memorial, Sports, & NGO.',
      'brand':
      {
        '@type': 'Thing',
        'name': 'Ketto.Org'
      },
      'aggregateRating':
      {
        '@type':
          'AggregateRating',
        'ratingValue':
          '4.5',
        'reviewCount':
          '1584'
      }
    };
    this.seoService.schemaOrgObject(reviewSchema, 'homeReview');
  }


  private loadSeoData() {
    this.metaData = this.seoService.homePageMetaTags();
    this.seoService.addMetaTags(this.metaData);
    this.seoService.meta.addTag({ name: 'google-site-verification', content: 'SqBykoY6M4bEc03AHmT_XSd3U51D3Kw0NRX_xXM5zXc' });
    this.seoService.meta.addTag({ name: 'google-site-verification', content: 'sUJxGJTW80o5MNVMSx9h3UwvwVKUrXzbmuS-yaXlZV0' })
    this.seoService.schemaOrgObject(this.seoService.schema.home_org);
    this.seoService.schemaOrgObject(this.seoService.schema.home_webpage);
    this.util.setPageTitle(`Crowdfunding India | #1 Indian Online Crowdfunding Website`);

  }

  ngOnDestroy() {
    this.seoService.removeMetaTags(this.metaData);
    if (typeof document !== 'undefined') {
      this.document.body.classList.remove('homePage');
    }
    if (this.ExitlistenerFn) {
      this.ExitlistenerFn();
    }
    this.subs.forEach(sub => sub.unsubscribe());
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView'
    };
    this.events.onLoadSystemEvent(pageViewPayload);
  }

  loadComponent(e, component) {
    if (e.visible === true && this.componentInView[component] === false) {
      this.componentInView[component] = true;
    }
  }

  /*Exit Intent Popup */
  openDialog(): void {
    const dialogRef = this.dialog.open(ExitIntentComponent, {
      width: '540px',
      maxHeight: this.util.isMobile() ? '100vh' : '524px',
      panelClass: 'exit-intent-dialog'
    });
  }

  exitIntent() {
    return this.renderer.listen('document', 'mouseout', (event) => {
      if (event.toElement == null && event.relatedTarget == null && event.clientY < 0) {
        if (this.popupCounter < 1 && this.util.storage.getFromSession('exitDialog') !== 'shown') {
          this.openDialog();
          this.util.storage.addSessionData('exitDialog', 'shown');

        }
        this.popupCounter++;
      }
    });
  }
}
